import { InstrumentLite } from '../quote/instrument-lite.model';

export class TrendModel {
    public mostTraded: InstrumentLite[] = [];
    public canUp: InstrumentLite[] = [];
    public canDown: InstrumentLite[] = [];
    public isLow: InstrumentLite[] = [];
    public isUp: InstrumentLite[] = [];

    // tslint:disable-next-line: no-empty
    constructor() {}
}